export default __webpack_public_path__ + "static/9408er-d505de5f941cbed015b251749650fa9b.jpg";